<ng-container
  *appLet="{
    featIsOn1077: gbs.growthBook.isOn(gbf.FEAT_US1077_MULTICITY),
    featValue1077: gbs.growthBook.getFeatureValue(gbf.FEAT_US1077_MULTICITY, ''),
    featIsOn1203: gbs.growthBook.isOn('feat-001203-seat-map-page-with-3d-panorama'),
    featValue1203: gbs.growthBook.getFeatureValue('feat-001203-seat-map-page-with-3d-panorama', ''),
    featIsOn1728: gbs.growthBook.isOn('feat-001728-skytrax-badge'),
    featValue1728: gbs.growthBook.getFeatureValue('feat-001728-skytrax-badge', ''),
    feature2389IsOn: gbs.isVariantOfExperimentEnabled('feat-002389-turning-off-cultures', 'b'),
    cultureName: cultureName$ | async,
  } as $comp"
>
  <section class="container-fluid" class="extended-footer">
    <div class="container">
      <div class="social-media-icons">
        <app-social-media-icons></app-social-media-icons>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-5 col-lg-4 col-xl-5 order-2 order-md-1 mt-4 mt-md-0"
        >
          <div
            class="logo-section d-flex flex-column h-100 justify-content-center"
          >
            <div class="logo">
              <a [routerLink]="'/' + culture">
                <img
                  src="https://assets.flynorse.com/static/site/NorseLogoWhite.svg"
                  alt="Norse Atlantic Airways Logo"
                />
              </a>
              <label class="fs-5 d-block lh-lg">{{ cmsCopy.tagLine }}</label>
            </div>
            <div class="tag fs-7 mt-3" [class.tag--small]="$comp.featIsOn1728 && $comp.featValue1728 === 'b'">
              {{ currentYear }} &copy;
              {{ cmsCopy.copyrightNorse }}
            </div>
            @if ($comp.featIsOn1728 && $comp.featValue1728 === 'b') {
              <div class="footer__skytrax">
                <p>{{ cmsCopy.skytraxText1}}<span>{{cmsCopy.skytraxText2}}</span></p>
                <img src="/assets/img/svg/skytrax-logo.svg" alt="Skytrax">
              </div>
            }
            @if ($comp.feature2389IsOn) {
              <div class="extended-footer__culture-dropdown">
                <app-culture-dropdown
                  [collapseCultures]="true"
                  [alignToLeft]="true"
                  [cultureCode]="culture"
                  [cultureName]="$comp.cultureName"
                ></app-culture-dropdown>
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-md-7 col-lg-8 col-xl-7 order-1 order-md-2">
          <nav class="row" role="navigation">
            <div class="col-6 col-lg">
              <div class="fs-3 fw-bold mb-2">{{ cmsCopy.navColumn1 }}</div>
              <ng-container *ngFor="let item of navCopy.navColumn1List">
                @if (item.link?.includes('seat-map')) {
                  @if ($comp.featIsOn1203 && $comp.featValue1203 === 'b') {
                    <app-link-display [linkItem]="item"></app-link-display>
                  }
                } @else {
                  <app-link-display [linkItem]="item"></app-link-display>
                }
              </ng-container>
              @if ($comp.featIsOn1077 && $comp.featValue1077 === 'b') {
                @for (link of navCopy.multiCityLink; track link) {
                  <app-link-display [linkItem]="link"></app-link-display>
                }
              }
            </div>
            <div class="col-6 col-lg">
              <div class="fs-3 fw-bold mb-2">{{ cmsCopy.navColumn2 }}</div>
              <ng-container *ngFor="let item of navCopy.navColumn2List">
                <app-link-display [linkItem]="item"></app-link-display>
              </ng-container>
            </div>
            <div class="col-6 col-lg mt-4 mt-lg-0">
              <div class="fs-3 fw-bold mb-2">{{ cmsCopy.navColumn3 }}</div>
              <ng-container *ngFor="let item of navCopy.navColumn3List">
                <app-link-display [linkItem]="item"></app-link-display>
              </ng-container>
            </div>
            <div class="col-6 col-lg mt-4 mt-lg-0">
              <div class="fs-3 fw-bold mb-2">{{ cmsCopy.navColumn4 }}</div>
              <ng-container *ngFor="let item of navCopy.navColumn4List">
                <app-link-display [linkItem]="item"></app-link-display>
              </ng-container>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </section>
</ng-container>

